export default "__VITE_ASSET__CK5VM1$i__"